module.exports = __webpack_public_path__ + "img/loading.6d0ea1e6.gif";